export default __webpack_public_path__ + "static/media/Key.501df16c.svg";